export const DESIGNS_QUERY_KEY = () => ["designs"];
export const DESIGN_QUERY_KEY = (designId) => ["designs", designId];
